module.exports = __webpack_public_path__ + "img/mexico-business-round-2023 copia.162181b5.png";